module.exports = __webpack_public_path__ + "img/Sample_Certificate_ACP.070607e1.png";